import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import Button from "../../../components/buttons/Button";

import "../components/tabs.scss";
import "../../../components/buttons/button.scss";

interface ITabs {
  children: any;
}

export default function Tabs({ children }: ITabs) {
  const userIcon = <i className="fa fa-user-circle"></i>;

  return (
    <div>
      <div className="tab-bar">
        <div className="tabs">
          <div>
            <NavLink
              to="/students"
              className={({ isActive }) =>
                isActive ? "active-link" : "tab-link"
              }
            >
              Profile
            </NavLink>
          </div>

          <div>
            <NavLink
              to="/something"
              className={({ isActive }) =>
                isActive ? "active-link" : "tab-link"
              }
            >
              Schedules
            </NavLink>
          </div>

          <div>
            <NavLink
              to="/something"
              className={({ isActive }) =>
                isActive ? "active-link" : "tab-link"
              }
            >
              Payment & Subscription
            </NavLink>
          </div>
        </div>

        <Button
          isLoading={false}
          name="Deactivate"
          type="deactivate-button"
          icon={
            <FontAwesomeIcon
              icon={faUserCircle}
              className="profile-icon-font-awesome"
            />
          }
        />
      </div>

      <div>{children}</div>
    </div>
  );
}
